import script from "./Insulation04Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Insulation04Details.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__